import { useCallback, useState } from 'react'
import { sendEnquiry } from '../services/cinch-servicing'
import { MaintenanceContext } from '../context/maintenance-context'
import { format } from 'date-fns'
import { isMobileApp } from '../utils'

export const useSendServicingEnquiry = () => {
  const [loading, setLoading] = useState(false)
  const [enquirySent, setEnquirySent] = useState<boolean>(false)
  const [error, setError] = useState<Error | null>(null)

  const sendServicingEnquiry = useCallback(
    async (
      {
        customerFirstName,
        customerSurname,
        customerEmail,
        customerPhone,
        postcode,
        contactTimePreference,
        store,
        displayName,
        storeId,
        serviceOptionsSelectedNames,
        appointmentType,
        bookingDate,
        bookingTime,
        notes,
        vehicleMake,
        vehicleModel,
        vehicleFuelType,
        vehicleVin,
        vrm,
        emailPermissions,
        dealerCode,
      }: MaintenanceContext,
      campaignId?: string,
    ) => {
      if (
        !customerFirstName ||
        !customerSurname ||
        !customerEmail ||
        !customerPhone ||
        !postcode ||
        !contactTimePreference ||
        !store ||
        !storeId ||
        !serviceOptionsSelectedNames ||
        !appointmentType ||
        !vehicleMake ||
        !vehicleModel ||
        !vehicleFuelType ||
        !vehicleVin ||
        !vrm
      ) {
        setLoading(false)
        setError(new Error('Missing Enquiry Value'))
        return
      }

      setLoading(true)
      setError(null)

      try {
        const isApp = isMobileApp()

        const success = await sendEnquiry({
          customer: {
            firstName: customerFirstName,
            lastName: customerSurname,
            email: customerEmail,
            phoneNumber: customerPhone,
            postcode,
            contactTimePreference,
          },
          enquiry: {
            storeName: store,
            storeDisplayName: displayName,
            storeId,
            serviceOptions: serviceOptionsSelectedNames.split(', '),
            appointmentType,
            ...(bookingDate
              ? {
                  preferredDate: format(
                    new Date(bookingDate),
                    'ccc dd MMM yyyy',
                  ),
                  preferredTime: bookingTime,
                }
              : {}),
            ...(notes ? { notes } : {}),
          },
          vehicle: {
            make: vehicleMake,
            model: vehicleModel,
            vrm,
            vin: vehicleVin,
            fuelType: vehicleFuelType,
          },
          ...(emailPermissions !== undefined
            ? { marketingPreferences: { email: emailPermissions } }
            : {}),
          campaignId,
          deviceContext: isApp ? 'app' : 'web',
          ...(dealerCode ? { dealerCode } : {}),
        })
        if (success) {
          setEnquirySent(true)
          setError(null)
        } else {
          setError(new Error('Enquiry failed to send'))
        }
      } catch (error) {
        setError(error as Error)
      } finally {
        setLoading(false)
      }
    },
    [],
  )

  return {
    sendServicingEnquiry,
    loading,
    enquirySent,
    error,
  }
}
